export default "__VITE_ASSET__BJcSFROF__"